import { faAngleDown, faPhone, faUserPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Image, Row, } from "react-bootstrap";
import * as Constants from "../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import { Circle, GirlImg, Vector_1, Vector_2, Vector_3, Vector_4, Vector_5, Vector_6, Vector_7, Vector_8 } from "../../../../../assets/images";

const MyProfileLab = () => {
    return (
        <div className="myprofile_main_area">
            <WithoutImageHeader
                header={Constants.MYPROFILE_LAB}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="profile_inner_area">
                            <div className="content_area">
                                <div className="img_area">
                                    <Image src={GirlImg} alt="..." />
                                </div>
                                <h5>Lauren Lopez</h5>
                                <div className="label">
                                    <p>Lab Assistance</p>
                                </div>
                            </div>
                            <div className="information_con_area">
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_1} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Contact Number</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>+91-798-798-7987</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_2} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Email</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>harjinder12@gmail.com</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_3} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Gender</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>Male</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_4} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Blood Group</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>O</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_5} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Date of Birth</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>26-05-1980</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_6} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Specialization</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>Diagnostic Testing</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_7} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Registration</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>105478</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="info_area">
                                    <div className="left_area">
                                        <div className="inner_area">
                                            <div className="left">
                                                <div className="icon_area">
                                                    <Image src={Vector_8} alt="..." />
                                                </div>
                                            </div>
                                            <div className="right">
                                                <p>Address</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="txt">
                                            <span>:</span>
                                            <p>107, Guru Nanak Pura, Civil Lines Ludhiana, Punjab</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="edit_btn">
                                    <a href="javascript:;">Edit Profile<FontAwesomeIcon icon={faUserPen} className="icon_edit" /></a>
                                </div>
                                <div className="circle_box">
                                    <Image src={Circle} alt="..." />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default MyProfileLab;
